export default __webpack_public_path__ + "static/media/logo.2d3b5105.svg";